import React from "react";
import PropTypes from "prop-types";
import { SORTING } from "../../../../constants/sorting";
import { DropdownItemIcons, Table } from "@weezevent/nacre";
import { getDataTypeFromDataColumn } from "./methods";
import { ROW_SELECTION_PROP_TYPES } from "../../proptypes";
import DropdownSortingLabel from "../dropdown-sorting-label";

const ColumnHeaderTitle = ({
	title,
	sortable,
	titleAlign,
	sortingActive,
	sortingDirection,
	sortingDropdownDisabled,
	columnData,
	preferredSortingType,
	customSortingLabels,
	onClickSorting,
	width
}) => {
	const renderSortingLabel = direction => (
		<DropdownSortingLabel
			dataType={getDataTypeFromDataColumn(columnData)}
			direction={direction}
			preferredType={preferredSortingType}
			customLabels={customSortingLabels}
		/>
	);

	const style = {
		textAlign: titleAlign,
		width: width || undefined
	};

	if (sortable) {
		let icon = "";

		if (sortingActive) {
			icon =
				sortingDirection === SORTING.DIRECTIONS.DESC
					? "arrow-bottom"
					: "arrow-top";
		} else {
			icon = "caret-bottom";
		}

		return (
			<th style={style}>
				<Table.DropdownSort
					active={sortingActive}
					label={title}
					icon={icon}
					size="medium"
					disabled={sortingDropdownDisabled}
					items={[
						<DropdownItemIcons
							checked={
								sortingActive &&
								sortingDirection === SORTING.DIRECTIONS.ASC
							}
							item={renderSortingLabel(SORTING.DIRECTIONS.ASC)}
							key={SORTING.DIRECTIONS.ASC}
							onClick={() =>
								onClickSorting(SORTING.DIRECTIONS.ASC)
							}
						/>,
						<DropdownItemIcons
							checked={
								sortingActive &&
								sortingDirection === SORTING.DIRECTIONS.DESC
							}
							item={renderSortingLabel(SORTING.DIRECTIONS.DESC)}
							key={SORTING.DIRECTIONS.DESC}
							onClick={() =>
								onClickSorting(SORTING.DIRECTIONS.DESC)
							}
						/>
					]}
				/>
			</th>
		);
	}

	return <th style={style}>{title}</th>;
};

ColumnHeaderTitle.propTypes = {
	title: PropTypes.string.isRequired,
	sortable: PropTypes.bool,
	titleAlign: ROW_SELECTION_PROP_TYPES.Align,
	sortingActive: PropTypes.bool,
	sortingDirection: ROW_SELECTION_PROP_TYPES.SortingDirections,
	sortingDropdownDisabled: PropTypes.bool,
	columnData: PropTypes.array,
	preferredSortingType: ROW_SELECTION_PROP_TYPES.SortingTypes,
	customSortingLabels: PropTypes.objectOf(
		ROW_SELECTION_PROP_TYPES.SortingDirections
	),
	onClickSorting: PropTypes.func,
	width: PropTypes.number
};

ColumnHeaderTitle.defaultProps = {
	sortable: false,
	titleAlign: "left",
	sortingActive: false,
	sortingDirection: null,
	sortingDropdownDisabled: false,
	columnData: [],
	preferredSortingType: null,
	customSortingLabels: null,
	onClickSorting: () => {},
	width: null
};

export default ColumnHeaderTitle;
